import { styled } from "goober";
import type { StepTestDotStatus } from "../../shared/stepTests/freshness";
import { ActivityStatusDot } from "./ActivityFooter";

const Dot = styled(ActivityStatusDot)`
  &[data-status="passed"] {
    background: var(--green-600);
  }
  &[data-status="failed"] {
    background: var(--red-600);
  }
  &[data-status="running"] {
    background: var(--gray-600);
  }
`;

export function StepTestStatusDot({ status }: { status: StepTestDotStatus }) {
  return (
    <Dot
      data-status={status}
      data-running={status === "running" || undefined}
      aria-label={status}
    />
  );
}
